import { useState, useCallback, useEffect } from 'react'

export type Tab = 'checkin' | 'data' | 'me'

const STORAGE_KEY = 'baby-log:tab'
const VALID: Tab[] = ['checkin', 'data', 'me']

function loadTab(): Tab {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    if (v && VALID.includes(v as Tab)) return v as Tab
  } catch {}
  return 'checkin'
}

export function useTab() {
  const [tab, setTabState] = useState<Tab>(loadTab)

  const setTab = useCallback((t: Tab) => {
    setTabState(t)
    try {
      localStorage.setItem(STORAGE_KEY, t)
    } catch {}
  }, [])

  // 同步 tab 标题
  useEffect(() => {
    const titles: Record<Tab, string> = {
      checkin: '打卡',
      data: '数据',
      me: '我的',
    }
    document.title = `${titles[tab]} · 宝宝记录`
  }, [tab])

  return { tab, setTab }
}
